import { useEffect, useState } from 'react';
import { ShippingOptionType } from '../../bff-api/baskets/model';
import { usePDP } from '../../contexts/pdp/usePDP';
import { isOutOfStock } from '../../utils/product-utils';
import { GetIcon } from '../icons';
import styles from './ExtendWarranty.module.scss';
import { EXTEND_COMPONENT_ID, useExtendWarranty } from './useExtendWarranty';

interface Params {
    productId: string;
    className?: string;
}

export const ExtendWarranty: React.FC<Params> = ({ productId, className }: Params) => {
    const [showOptions, setShowOptions] = useState(false);

    const { product, selectedShippingOptionType } = usePDP();
    const { init, updateWidgetStyle, isAvailable, isPDPEnabled, isSdkLoaded } = useExtendWarranty();

    useEffect(() => {
        if (isSdkLoaded) {
            init(productId);
        }
    }, [init, productId, isSdkLoaded]);

    if (!isPDPEnabled || !product || !product.c_isExtendEligible || !isSdkLoaded) {
        return null;
    }

    updateWidgetStyle();

    const onToggleOptions = (): void => setShowOptions(!showOptions);

    const available =
        selectedShippingOptionType === ShippingOptionType.SHIP_TO &&
        !isOutOfStock(product) &&
        isAvailable;

    return (
        <div
            data-testid="extend-container"
            className={`relative ${showOptions ? styles.extend_open : styles.extend_closed} ${
                available ? '' : 'hidden'
            } ${className}`}
        >
            <div data-testid={EXTEND_COMPONENT_ID} id={EXTEND_COMPONENT_ID} />

            <button
                data-testid={`${EXTEND_COMPONENT_ID}-show-options-button`}
                type="button"
                className="absolute right-0 top-0 w-1/4 text-end"
                onClick={onToggleOptions}
            >
                <GetIcon
                    name={showOptions ? 'dropdown-arrow-close' : 'dropdown-arrow-open'}
                    size="md"
                />
            </button>
        </div>
    );
};

ExtendWarranty.defaultProps = {
    className: undefined,
};
